import axios from "axios";
import {
  GET_TOURS,
  TOUR_ERROR,
  UPDATE_TOUR_LIKES,
  DELETE_TOUR,
  ADD_TOUR,
  GET_TOUR,
  CLEAR_TOURS,
} from "./types";

// Get tours
export const getTours = () => async (dispatch) => {
  try {
    const res = await axios.get("/api/vrtours");

    dispatch({
      type: GET_TOURS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: TOUR_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get user's tours
export const getToursById = (channelid) => async (dispatch) => {
  dispatch({ type: CLEAR_TOURS });

  try {
    const res = await axios.get(`/api/vrtours/${channelid}`);
    dispatch({ type: CLEAR_TOURS });

    dispatch({
      type: GET_TOURS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: TOUR_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get tour
export const getTourById = (channelid, id) => async (dispatch) => {
  dispatch({ type: CLEAR_TOURS });

  try {
    const res = await axios.get(`/api/vrtours/${channelid}/${id}`);

    dispatch({ type: CLEAR_TOURS });

    dispatch({
      type: GET_TOUR,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: TOUR_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Add tour
export const addTour =
  (savedData, file, tourImage, tourTitle) => async (dispatch) => {
    const formData = new FormData();
    formData.append("tourvideo", file);
    formData.append("tourposter", tourImage);
    formData.append("tourtitle", JSON.stringify(tourTitle));
    formData.append("tourblocks", JSON.stringify(savedData));

    const config = {
      data: formData,
      header: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    };

    try {
      const res = await axios.post("/create_vrtour", formData, config);

      dispatch({
        type: ADD_TOUR,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: TOUR_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

// Add tour like
export const addTourLike = (id) => async (dispatch) => {
  try {
    const res = await axios.put(`/api/vrtours/like/${id}`);

    dispatch({
      type: UPDATE_TOUR_LIKES,
      payload: { id, likes: res.data },
    });
  } catch (err) {
    dispatch({
      type: TOUR_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Remove tour like
export const removeTourLike = (id) => async (dispatch) => {
  try {
    const res = await axios.put(`/api/vrtours/unlike/${id}`);

    dispatch({
      type: UPDATE_TOUR_LIKES,
      payload: { id, likes: res.data },
    });
  } catch (err) {
    dispatch({
      type: TOUR_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Delete tour
export const deleteTour = (id) => async (dispatch) => {
  try {
    await axios.delete(`/api/vrtours/${id}`);

    dispatch({
      type: DELETE_TOUR,
      payload: id,
    });
  } catch (err) {
    dispatch({
      type: TOUR_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};
